import type { ScheduleForecastState } from "../../domain/weather";
import type { TeamAppModel } from "../../hooks/teamTypes";
import { DefenseRoute } from "./DefenseRoute";
import { GameRoute } from "./GameRoute";
import { HistoryRoute } from "./HistoryRoute";
import { ScheduleRoute } from "./ScheduleRoute";
import { SetupRoute } from "./SetupRoute";

interface TeamRouteContentProps {
  model: TeamAppModel;
  weatherByEntryId: Record<string, ScheduleForecastState>;
  setupWeatherState?: ScheduleForecastState;
  onRetryWeather: () => void;
  weatherRefreshing?: boolean;
  onPrint: () => void;
}

export function TeamRouteContent({
  model,
  weatherByEntryId,
  setupWeatherState,
  onRetryWeather,
  weatherRefreshing = false,
  onPrint,
}: TeamRouteContentProps) {
  switch (model.shell.screen) {
    case "setup":
      return (
        <SetupRoute
          model={model}
          {...(setupWeatherState ? { weatherState: setupWeatherState } : {})}
          onRetryWeather={onRetryWeather}
          weatherRefreshing={weatherRefreshing}
        />
      );
    case "schedule":
      return (
        <ScheduleRoute
          model={model}
          weatherByEntryId={weatherByEntryId}
          onRetryWeather={onRetryWeather}
          weatherRefreshing={weatherRefreshing}
        />
      );
    case "result":
    case "stats":
    case "season":
      return <HistoryRoute model={model} />;
    case "defense":
    case "defexport":
      return <DefenseRoute model={model} onPrint={onPrint} />;
    case "game":
      return <GameRoute model={model} />;
  }
}
